module.exports = __webpack_public_path__ + "img/LoveIs.de18d6d9.svg";